import { render } from "./Tours.vue?vue&type=template&id=772059ec&scoped=true"
import script from "./Tours.vue?vue&type=script&lang=js"
export * from "./Tours.vue?vue&type=script&lang=js"

import "./Tours.vue?vue&type=style&index=0&id=772059ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772059ec"]])

export default __exports__